import { ActionTree } from "vuex";
import { RootState } from "..";
import { PlatformLogsState } from "./platformLogs.module";
import { platformLogsRequests } from "@/https/platform-logs.https";
import { PlatformLogsFilters } from "@/interfaces/panel/platform-logs.model";

export const PLATFORM_LOGS_ACTIONS: ActionTree<PlatformLogsState, RootState> = {
    async fetchPlatformLogs({ commit }, filters?: PlatformLogsFilters) {
        try {
            commit("SET_LOADING", true);
            const response = await platformLogsRequests.GetPlatformLogs(filters);

            if (response.data.success) {
                commit("SET_PLATFORM_LOGS", response.data.data.items);
                commit("SET_PAGINATION", response.data.data.pagination);
                commit("SET_STATS", response.data.data.stats);
                commit("SET_APPLIED_FILTERS", response.data.data.appliedFilters);
            }

            return response.data;
        } catch (error) {
            console.error("Error fetching platform logs:", error);
            throw error;
        } finally {
            commit("SET_LOADING", false);
        }
    },

    updateFilters({ commit, dispatch }, filters: PlatformLogsFilters) {
        commit("SET_FILTERS", filters);
        return dispatch("fetchPlatformLogs", filters);
    },

    resetFilters({ commit, dispatch }) {
        commit("RESET_FILTERS");
        return dispatch("fetchPlatformLogs");
    },
};
